/*
Filter: by Theme
*/

jQuery(document).ready(function() {
	// Insert a filter for theme of aspirations
	jQuery('.filter-by-theme').html('<p class="heading--filter">Filter by: </p><ul class="filter--choices"><li class="filter--choice innovative on">Innovative</li><li class="filter--choice productive">Productive</li><li class="filter--choice collaborative">Collaborative</li><li class="filter--choice whole-city">Whole city</li></ul>');

	jQuery('.filter--choice').click(function(){
		jQuery('.filter--choice').removeClass('on');
		jQuery(this).addClass('on');
    	theme = jQuery(this).attr('class').split(' ')[1];
        //alert("You just filtered by "+theme);
        // Hide all the other themes
        jQuery('div.outcome').hide();
        // Show the theme we want
        jQuery('div.outcome.'+theme).show();
    });
}); 